import { BaseView, Component } from '../services/RoutingService';
    
type UserRole = 'PUB' | 'APP' | 'INT' | 'BRA' | 'AGY' | 'OFF' | 'PRE' | 'PRE_INT';

export interface AccessLevel<T> {
    controllerAs?: string

    everyone?: T
    anon?: T
    applicant?: T
    interviewer?: T
    agency?: T
    branch?: T
    office?: T
    customer?: T
    staff?: T
    preloggedin?: T
    loggedin?: T
    loggedinNonSocial?: T
    applicantSocial?: T
    invalidApplicant?: T

    [name: string]: T|string
}

export interface AccessLevelView extends AccessLevel<Component>, BaseView {

}


interface AccessLevelDefinition {
    roles?: UserRole[],
    condition?: any[]
}


var canAupairExtendPromise;
function canAupairExtend(Auth, USAuPairs, condition) {
    if (!Auth.user.usAccessToken.length) {
        return false;
    }

    if (!canAupairExtendPromise) {
        canAupairExtendPromise = USAuPairs.canAupairExtend({ aupairId: Auth.user.usAuPairId }).$promise
    }

    return canAupairExtendPromise.then((response) => {
        if (response.data && condition(response.data)) {
            return true;
        }
        else
            return false;
    }, () => false);
}

var definition: AccessLevel<AccessLevelDefinition> = {
    everyone: {},
    anon: { roles: ['PUB'] },
    applicant: { roles: ['APP'] },
    interviewer: { roles: ['INT'] },
    agency: { roles: ['AGY'] },
    branch: { roles: ['BRA'] },
    office: { roles: ['OFF'] },
    customer: { roles: ['PUB', 'APP', 'PRE', 'PRE_INT'] },
    staff: { roles: ['INT', 'BRA', 'AGY', 'OFF'] },
    preloggedin: { roles: ['PRE'] },
    loggedin: { roles: ['APP', 'INT', 'BRA', 'AGY', 'OFF', 'PRE', 'PRE_INT'] },
    loggedinNonSocial: {
        roles: ['APP', 'INT', 'BRA', 'AGY', 'OFF', 'PRE', 'PRE_INT'],
        condition: ['Auth', function (Auth) {
            return !Auth.user.isSocial;
        }]
    },
    applicantSocial: {
        roles: ['APP'],
        condition: ['Auth', function (Auth) {
            return Auth.user.isSocial;
        }]
    },
    awlApplicant: {
        roles: ['APP'],
        condition: ['ApplicationInstance', 'Auth', function (ApplicationInstance, Auth) {
            return ApplicationInstance(Auth.user.roleDetails.applicationId)
                .toPromise()
                .then(function (data) {
                    var invalidStatus = ['AWL'];
                    if (invalidStatus.indexOf(data.status) >= 0) {
                        console.log('application status is AWL')
                        return true;
                    }

                    return false;
                });
        }]
    },
    preInterview: {
        roles: ['PRE_INT'],
        condition: ['ApplicationInstance', 'Auth', function (ApplicationInstance, Auth) {
            return ApplicationInstance(Auth.user.roleDetails.applicationId)
                .toPromise()
                .then(function (data) {
                    var invalidStatus = ['DNQ', 'REJ', 'CAN', 'FAI', 'TXP', 'APD', 'ARC'];
                    if (invalidStatus.indexOf(data.status) >= 0) {
                        return false;
                    }

                    return true;
                });
        }]
    },
    invalidApplicant: {
        roles: ['APP', 'PRE_INT'],
        condition: ['ApplicationInstance', 'Auth', function (ApplicationInstance, Auth) {
            return ApplicationInstance(Auth.user.roleDetails.applicationId)
                .toPromise()
                .then(function (data) {
                    var invalidStatus = ['DNQ','REJ','CAN','FAI','TXP','APD','ARC'];
                    if (invalidStatus.indexOf(data.status) >= 0) {
                        console.log('application status is indeed refreshed for invalid')
                        return true;
                    }

                    return false;
                });
        }]
    },
    extensionFlightApplicant: {
        roles: ['APP'],
        condition: ['Auth', 'USAuPairs', function (Auth, USAuPairs) {
            return canAupairExtend(Auth, USAuPairs, (data) => data.isOkToShowExtensionMenu && (data.isOkToShowHomeFlight || data.isOkToShowExtensionFlight));
        }]
    },
    extensionApplicant: {
        roles: ['APP'],
        condition: ['Auth', 'USAuPairs', function (Auth, USAuPairs) {                   
            return canAupairExtend(Auth, USAuPairs, (data) => data.isOkToShowExtensionMenu && !(data.isOkToShowHomeFlight || data.isOkToShowExtensionFlight));
        }]
    },
    flightApplicant: {
        roles: ['APP'],
        condition: ['Auth', 'USAuPairs', function (Auth, USAuPairs) {
            return canAupairExtend(Auth, USAuPairs, (data) => (data.isOkToShowHomeFlight || data.isOkToShowExtensionFlight) && !data.isOkToShowExtensionMenu);
        }]
    }
}

class AccessLevelConfig {
    static $inject = ['AccessLevelProvider']
    constructor(AccessLevelProvider) {
        for (let name of Object.keys(definition)) {
            AccessLevelProvider.accesslevel(name, definition[name]);
        }
    }
}

angular
    .module('app')
    .config(AccessLevelConfig);